export type DateTime = { date: string; time?: string };

export const dateAndTimeToMilliseconds = ({ date, time }: DateTime) =>
  new Date(`${date}${time ? ' ' + time : ''}`).getTime();
